import type { GetFeaturesInnerParams } from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';
import { getFacilities } from '@/app/components/search/components/Card/utils/getFacilities.tsx';
import { getTotalNumChildrenInfants } from '@/utils/peopleUtils.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { Feature } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';

export const getFacilitiesFeatures = ({
  isHO,
  features,
  accommodation,
  imageBasePath,
  t,
  searchParams,
}: GetFeaturesInnerParams): Feature[] => {
  const maxFeatures = 3;

  if (!isHO || features.length >= maxFeatures || !accommodation?.facilities) return [];

  const max = maxFeatures - features.length;
  return getFacilities({
    facilities: accommodation.facilities,
    imageBasePath,
    max,
    t,
    hasChildren: getTotalNumChildrenInfants(searchParams[URLParameters.AGES]) > 0,
    showIcons: isHO,
  });
};
